import { Component, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';

import { LoginService } from './../login.service';
import { GeoServices } from '../../../services/geo.service';
import { ConfigService } from '../../../services/config.service';
import { FormComponentI } from '../../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../../shared/models/internal-state-event';
import { TranslateService } from 'ng2-translate';
import { NotificationService } from '../../../components/notification/notification.service';
import { StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import { TemplateCurrentState, TemplateCurrentStateArgument } from 'nm-socle-application/app/shared/models/template-current-state';
import { LoginResultComponent } from 'nm-socle-application/app/components/login/login-result/login-result.component';
import { AbstractComponent } from 'nm-socle-application/app/shared/models/abstract-component';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'login-pass-lost-form',
    templateUrl: './login-pass-lost-form.component.html',
    styleUrls: ['./login-pass-lost-form.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LoginPassLostFormComponent extends AbstractComponent implements FormComponentI {
    @ViewChild('lostPasswordForm') public lostPasswordForm:NgForm;
    public customerId: number = null;
    public login: string;
    public email: string;

    public requestPasswordError: string;

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];
    
    public get canSend():boolean {
        return this.lostPasswordForm != undefined && this.lostPasswordForm.valid && this.lostPasswordForm.touched && !this.geoServices.isRequesting;
    }

    constructor(
        public loginService: LoginService,
        public geoServices: GeoServices,
        protected _configService: ConfigService,
        protected _translateService: TranslateService,
        protected _cd:ChangeDetectorRef,
        protected _templateInitService: TemplateInitService,
    ) {
        super(_cd);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.customerId = this._configService.get('customerId');

        this.markForCheck();
        this._cd.detectChanges();
    }

    // TODO : rendre paramétrable
    public toggleLoginForm() {
        this._templateInitService.setCurrentState(new TemplateCurrentState({state: 'login'}));
    }

    public submitLostPassword() {
        if(this.canSend) {
            this.requestPasswordError = undefined;
            this._configService.put('customerId', this.customerId);
            this.loginService.sendLostPasswordRequest(this.email, this.login).subscribe((status) => {
                this.markForCheck();

                if(status == LoginResultComponent.SUCCESS || status == LoginResultComponent.PENDING) {
                    NotificationService.notify(this._translateService.instant('login.notification.sent'), this._translateService.instant('login.notification.password-recovery'));

                    let curState:TemplateCurrentState = new TemplateCurrentState({state: 'loginPassLostResult', args: [
                        new TemplateCurrentStateArgument({name:"valid", value:status})
                    ]});

                    this._templateInitService.setCurrentState(curState);
                    this.markForCheck();
                }

                this.requestPasswordError = 'Mot de passe non envoyé, n\'hésitez pas à nous contacter directement'; // TODO trad
                this.markForCheck();
            },
            err => {
                this.requestPasswordError = err;
                this.markForCheck();
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/login/login-pass-lost-form/login-pass-lost-form.component.ts